/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ManagedBackupAgentsStore } from '../stores/ManagedBackupAgentsStore';

export const ManagedBackupAgentsContext = createContext<ManagedBackupAgentsStore>({} as ManagedBackupAgentsStore);
